<template>
  <span class="stars">
    <img
      :src="filledStarImageSrc"
      :height="size"
      :width="size"
      v-for="i in filledStarCount"
      :key="'filled-' + i"
    />
    <img
      :src="filledStarHalfImageSrc"
      :height="size"
      :width="size"
      v-for="i in filledStarHalfCount"
      :key="'half-' + i"
    />
    <img
      :src="filledStarGrayImageSrc"
      :height="size"
      :width="size"
      v-for="i in filledStarGrayCount"
      :key="'gray-' + i"
    />
  </span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";

const STAR_COUNT = 5;

@Component
export default class FiveStars extends Vue {
  @Prop({
    required: true,
    validator: prop => typeof prop === "number" || prop === null
  })
  value!: number | null;

  @Prop({
    default: "16",
    type: String
  })
  size!: string;

  @Prop({
    default: require("@/assets/svg/star/filled_star.svg"),
    type: String
  })
  filledStarImageSrc!: string;

  @Prop({
    default: require("@/assets/svg/star/filled_star_half.svg"),
    type: String
  })
  filledStarHalfImageSrc!: string;

  @Prop({
    default: require("@/assets/svg/star/filled_star_gray.svg"),
    type: String
  })
  filledStarGrayImageSrc!: string;

  get filledStarCount() {
    if (!this.value) return 0;
    return Math.floor(this.value);
  }

  get filledStarHalfCount() {
    if (!this.value) return 0;
    return this.value % 1 >= 0.5 ? 1 : 0;
  }

  get filledStarGrayCount() {
    return STAR_COUNT - this.filledStarCount - this.filledStarHalfCount;
  }
}
</script>

<style lang="scss" scoped>
.stars {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
</style>
